import React from 'react';
import PsychologyIcon from '@mui/icons-material/Psychology';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import HistoryIcon from '@mui/icons-material/History';
import InsightsIcon from '@mui/icons-material/Insights';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import PieChartOutlineIcon from '@mui/icons-material/PieChartOutline';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import SpeedIcon from '@mui/icons-material/Speed';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import InventoryIcon from '@mui/icons-material/Inventory';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';

/**
 * Ícone de cada relatório.
 *
 * Fica fora de `relatorios.js` porque aquele arquivo é só dados e é importado
 * pelas rotas; aqui há JSX. Ficava dentro de Relatorios.jsx, mas a página de
 * cada relatório passou a mostrar o mesmo ícone no cabeçalho, e duas cópias do
 * mapa divergiriam.
 */
const SX = { fontSize: 26, color: 'primary.main' };

export const ICONES_RELATORIO = {
    psicologos: <PsychologyIcon sx={SX} />,
    pacientes: <GroupOutlinedIcon sx={SX} />,
    usuarios: <ManageAccountsIcon sx={SX} />,
    'contas-receber': <PaidOutlinedIcon sx={SX} />,
    'sessoes-periodo': <EventAvailableIcon sx={SX} />,
    'sessoes-paciente': <HistoryIcon sx={SX} />,
    'sessoes-psicologo': <InsightsIcon sx={SX} />,
    'agenda-ocupacao': <CalendarMonthIcon sx={SX} />,
    'fila-espera': <FormatListBulletedIcon sx={SX} />,
    'faltas-cancelamentos': <EventBusyIcon sx={SX} />,
    'avaliacao-risco': <WarningAmberIcon sx={SX} />,
    'contas-pagar': <PaymentsOutlinedIcon sx={SX} />,
    'despesas-categoria': <PieChartOutlineIcon sx={SX} />,
    'despesas-recorrentes': <AutorenewIcon sx={SX} />,
    'pagamentos-periodo': <ReceiptLongIcon sx={SX} />,
    'despesas-psicologo': <PersonOutlineIcon sx={SX} />,
    'recebimentos-periodo': <PaidOutlinedIcon sx={SX} />,
    inadimplencia: <WarningAmberIcon sx={SX} />,
    'receita-paciente': <GroupOutlinedIcon sx={SX} />,
    'previsao-recebimentos': <InsightsIcon sx={SX} />,
    'recibos-emitidos': <ReceiptLongIcon sx={SX} />,
    'contas-bancarias': <AccountBalanceIcon sx={SX} />,
    'saldos-conta': <AccountBalanceWalletIcon sx={SX} />,
    'contas-psicologo': <PersonOutlineIcon sx={SX} />,
    'movimentacao-conta': <SwapVertIcon sx={SX} />,
    'planos-pagamento': <CreditCardIcon sx={SX} />,
    'faturamento-plano': <PaidOutlinedIcon sx={SX} />,
    'uso-planos': <PieChartOutlineIcon sx={SX} />,
    'fluxo-caixa': <ShowChartIcon sx={SX} />,
    'resultado-dre': <AssessmentIcon sx={SX} />,
    'faturamento-mensal': <TrendingUpIcon sx={SX} />,
    'receitas-forma-pagamento': <LocalAtmIcon sx={SX} />,
    'ticket-medio': <SpeedIcon sx={SX} />,
    anamneses: <AssignmentIndIcon sx={SX} />,
    'prontuarios-cid': <MedicalInformationIcon sx={SX} />,
    'assinaturas-ativas': <CardMembershipIcon sx={SX} />,
    'renovacoes-periodo': <AutorenewIcon sx={SX} />,
    'guias-lote': <InventoryIcon sx={SX} />,
    'repasse-plano-saude': <HealthAndSafetyIcon sx={SX} />,
    'documentos-emitidos': <HistoryEduIcon sx={SX} />,
};

/** Chave sem ícone próprio cai no genérico, em vez de furo no layout. */
export const iconeDoRelatorio = (chave) =>
    ICONES_RELATORIO[chave] ?? <AssessmentOutlinedIcon sx={SX} />;

export default ICONES_RELATORIO;
